export { useSwrStaticPhoneCountries } from './useSwrStaticPhoneCountries';
export { useSwrSpokenLanguages } from './useSwrSpokenLanguages';
export { useSwrSpokenLanguagesLevels } from './useSwrSpokenLanguagesLevels';
export { useSwrStaticSalaryCurrencies } from './useSwrStaticSalaryCurrencies';
export { useSwrDefaultSelfInterview } from './useSwrDefaultSelfInterview';
export { useSwrStaticStudyLevels } from './useSwrStaticStudyLevels';
